window.PreviewHelper = {
    createBlobUrl: function (base64, mimeType) {
        const bytes = atob(base64);
        const buffer = new Uint8Array(bytes.length);
        for (let i = 0; i < bytes.length; i++) {
            buffer[i] = bytes.charCodeAt(i);
        }
        const blob = new Blob([buffer], { type: mimeType });
        return URL.createObjectURL(blob);
    },
    revokeBlobUrl: function (url) {
        if (url && url.startsWith('blob:')) {
            URL.revokeObjectURL(url);
        }
    }
};
